'use client';
import { resolveImageUrl } from '@/shared/utils/publishingAsset';

import s from './GuideProduct.module.scss';
import { Carousel } from '@publishing/modules/carousel/Carousel';
import { Autoplay } from 'swiper';
import type { GuideProductImage } from './GuideProduct';
import { resolveResponsiveImage } from '@publishing/helpers/responsive';
import { Picture } from '@publishing/components/ui/Picture';

interface GuideProductImageSliderProps {
  images: GuideProductImage[];
  alt?: string;
}

export default function GuideProductImageSlider({ images, alt }: GuideProductImageSliderProps) {
  return (
    <Carousel
      modules={[Autoplay]}
      slidesPerView={1}
      gap={0}
      loop
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      className={s.guide_product_carousel}
    >
      {images.map((image, index) => {
        const [img, imgMo] = resolveResponsiveImage(image);

        return (
          <Picture
            key={`${resolveImageUrl(img)}-${index}`}
            src={img}
            mobileSrc={imgMo}
            alt={alt ?? ''}
            width={1054}
            height={544}
            className={s.guide_product_picture}
          />
        );
      })}
    </Carousel>
  );
}
